import {add_comment, delete_comment,mark_as_read} from "../../api/td_comment.api"


const getDefaultState = () => {
    return {
        td_comments: []
    }
}

// initial state
const state = getDefaultState()


const mutations = {
    set_td_comments(state, td_comments) {
        state.td_comments = td_comments
    },

    add_comment(state, comment) {
        state.td_comments = [ ...state.td_comments,comment]
    },

    delete_td_comment(state, comment) {
        state.td_comments = state.td_comments.filter(function( obj )
        {
            return obj.id !== comment.id;
        })
    },
    update_comment(state, comment) {
        state.td_comments = [
            ...state.td_comments.filter(element => element.id !== comment.id),
            comment
        ]
    },
    resetState (state) {
        Object.assign(state, getDefaultState())
    }

}

const actions = {

    mark_as_read({state, commit}, id) {
        console.log(id)
        // On met à jour la base
        return new Promise((resolve, reject) =>
            mark_as_read(id)
                .then((response) => {
                    if (response.status == '200') {

                        //commit('update_order_detail_warehouse',order_detail);
                        this._vm.$message({
                            message: 'Update commentaire OK',
                            type: 'success',
                            center: true
                        });
                        resolve(response);

                    }
                })
                .catch(error => {
                    //commit('update_order_detail_warehouse',order_detail);
                    this._vm.$message({
                        message: 'Suppression commentaire KO',
                        type: 'success',
                        center: true
                    });
                    reject(error);
                })
        )
    },

    comment_add({state, commit}, comment) {

        // On met à jour la base
        return new Promise((resolve, reject) =>
            add_comment(comment)
                .then((response) => {
                    if (response.status == '200') {

                        // On commit dans le state
                        //commit('add_comment', response.data.comment)

                        resolve(response);
                    }
                })
                .catch(error => {
                    reject(error);
                })
        )
    },
    comment_delete({state, commit}, id) {

        // On met à jour la base
        return new Promise((resolve, reject) =>
            delete_comment(id)
                .then((response) => {
                    if (response.status == '200') {

                        // On commit dans le state
                        //commit('delete_comment', comment)

                        //commit('update_order_detail_warehouse',order_detail);
                        this._vm.$message({
                            message: 'Suppression commentaire OK',
                            type: 'success',
                            center: true
                        });

                    }
                })
                .catch(error => {
                    //commit('update_order_detail_warehouse',order_detail);
                    this._vm.$message({
                        message: 'Suppression commentaire KO',
                        type: 'success',
                        center: true
                    });
                })
        )
    }
}

const getters = {
    todoComments: (state => (id_todo) => {
       return state.td_comments.filter(item => item.commentable_id === id_todo)
    })
}


export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}